import { render, staticRenderFns } from "./pl-PL.vue?vue&type=template&id=f0b6f47c&scoped=true&"
var script = {}
import style0 from "./pl-PL.vue?vue&type=style&index=0&id=f0b6f47c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b6f47c",
  null
  
)

export default component.exports